<script lang="ts">
	import { _CategoriesEnum_t, _SortingEnum } from '$lib/utils/Enums';
	import EshopListLayout from '../../(components)/EshopListLayout.svelte';
	import { page } from '$app/stores';
	import {resolveImageByUrlString} from "$lib/helpers/universalCategoryImageByUrlResolver";
	import {browser} from "$app/environment";
	import {onMount} from "svelte";
	export let data;
	let breadcrumbsData = [
		{ name: 'Univerzální díly', link: '/univerzalni-dily' },
		{ name: data?.subcategoryProducts?.category_name, link: data.slug }
	];

	onMount(async () => {
		if (browser) {
			window.scrollTo(0, 0);
		}
	});

	$: {
		page.subscribe(($page) => {
			data.sorting = $page.data.sorting;
			data.subcategoryProducts = $page.data.subcategoryProducts;
		});
	}
	
</script>

<svelte:head>
	<title>Univerzální {data?.subcategoryProducts?.category_name} na skútr</title>
	<meta name="description" content={data?.subcategoryProducts?.category_description} />
	<link rel="canonical" href={`https://www.scootland.cz/univerzalni-dily/${data?.slug}/`} />
	<meta property="og:image" content={resolveImageByUrlString(data?.slug)} >
	<meta property="og:title" content="Univerzální {data?.subcategoryProducts?.category_name} na skútr" />
	<meta property="og:description" content={data?.subcategoryProducts?.category_description}/>
	<meta property="og:image" content={resolveImageByUrlString(data?.slug)}/>
	<meta property="og:url" content="https://www.scootland.cz/univerzalni-dily/{data?.slug}/"/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
</svelte:head>

<EshopListLayout prerenderCommand={true} categoryType={_CategoriesEnum_t.UNI} {data} {breadcrumbsData} showCompatibility={false} />
